import React, { useState, useEffect, useMemo } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import TablaGeneral from "../../components/TablaGeneral";
import Loader from "../../components/Loader";
import configTable from "../../hook/configTable";
import { useAuth } from "../../auth/AuthProvider";

const EscaneosPage = () => {
  const auth = useAuth();
  const esAdmin = auth.user?.tipo === 1 || auth.user?.tipo === 2;
  const [isLoading, setIsLoading] = useState(true);
  const [datos, setDatos] = useState([]);
  const [filtroEstado, setFiltroEstado] = useState("todos");

  const eliminarItem = (id) => {
    console.log('eliminarItem', id);
    setIsLoading(true);
    try {
      fetch("/p_escaneo",{
        method: "DELETE",
        headers:{
          "Content-Type": "application/json",
        },
        body: JSON.stringify({id})
      })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setDatos([]);
        cargarDatos();
      });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const datosTabla = useMemo(() => ({
    titulo: "Escaneos",
    ruta: "/escaneo",
    esAgregar: true,
    esEditar: true,
    esEliminar: !!esAdmin,
    eliminar: eliminarItem,
    configTable: configTable,
    keySucursal: "ID_SUC_ESC"
  }), [esAdmin]);

  const [cabecera] = useState([
    { title: "ID", key: "ID_ESC" },
    { title: "NOMBRE", key: "NOMBRES_DP" },
    { title: "APELLIDO PATERNO", key: "APELLIDO_PATERNO_DP" },
    { title: "APELLIDO MATERNO", key: "APELLIDO_MATERNO_DP" },
    { title: "SUCURSAL", key: "NOMBRE_SUCURSAL_SUC" },
    { 
      title: "ESTADO", 
      key: "CONSUMO_ESC", 
      render: (data, type, row) => {
        const completado = row.GASTO_TOTAL_ESC > 0 || (row.CONSUMO_ESC && row.CONSUMO_ESC.toString().trim() !== "");
        return completado 
          ? `<span class="badge bg-success-focus text-success-main text-xs px-12 py-4 radius-8">Completado</span>`
          : `<span class="badge bg-warning-focus text-warning-main text-xs px-12 py-4 radius-8">Incompleto</span>`;
      }
    },
    { title: "ULTIMO ESCANEO", key: "FECHA_ALTA_ESC", isDate: true },
  ]);

  const cargarDatos = async () => {
    try {
      fetch("/p_escaneos",{
        method: "GET",
        headers:{
          "Content-Type": "application/json",
        }
      })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if(data.status === 1){
          setDatos(data.data);
        }
        setIsLoading(false);
      });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);

  const obtenerDatosFiltrados = () => {
    if (filtroEstado === "completados") {
      return datos.filter(item => item.GASTO_TOTAL_ESC > 0 || (item.CONSUMO_ESC && item.CONSUMO_ESC.toString().trim() !== ""));
    }
    if (filtroEstado === "incompletos") {
      return datos.filter(item => !item.GASTO_TOTAL_ESC && (!item.CONSUMO_ESC || item.CONSUMO_ESC.toString().trim() === ""));
    }
    return datos;
  };

  return (
    <>
      <MasterLayout>
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
          <div>
            <h6 className="text-lg mb-1">Escaneos</h6>
            <p className="text-sm text-secondary-light mb-0">Listado de escaneos registrados en el sistema</p>
          </div>
        </div>

        {/* Pestañas de Filtro de Estado */}
        <div className="d-flex align-items-center gap-2 mb-20">
          <button
            onClick={() => setFiltroEstado("todos")}
            className={`btn text-sm px-20 py-10 radius-8 ${filtroEstado === "todos" ? "btn-primary" : "btn-outline-primary border-primary-100 text-secondary-light"}`}
          >
            Todos
          </button>
          <button
            onClick={() => setFiltroEstado("completados")}
            className={`btn text-sm px-20 py-10 radius-8 ${filtroEstado === "completados" ? "btn-success bg-success-600 text-white" : "btn-outline-success border-success-100 text-secondary-light"}`}
          >
            Completados
          </button>
          <button
            onClick={() => setFiltroEstado("incompletos")}
            className={`btn text-sm px-20 py-10 radius-8 ${filtroEstado === "incompletos" ? "btn-warning bg-warning-600 text-white" : "btn-outline-warning border-warning-100 text-secondary-light"}`}
          >
            Incompletos
          </button>
        </div>

        { isLoading ? <Loader /> : <TablaGeneral datosTabla={datosTabla} datos={obtenerDatosFiltrados()} cabecera={cabecera}/> }
      </MasterLayout>
    </>
  );
};

export default EscaneosPage;
